(function ($, window) {
	'use strict';

	$(function () {
		$('.jsPartnersSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			new Swiper($slider, {
				centeredSlides: true,
				speed: 6000,
				autoplay: {
					delay: 1,
				},
				loop: true,
				slidesPerView: 2,
				spaceBetween: 30,
				// slidesPerView:'auto',
				allowTouchMove: false,
				pauseOnMouseEnter: true,
				disableOnInteraction: true,
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 60
					},
					1024: {
						slidesPerView: 6,
						spaceBetween: 80
					}
				}
			});
		});
	});
})(jQuery, window);
